import FingerprintJs from 'fingerprintjs2'

let fingerprint

const device = Object.freeze({
  get fingerprint () {
    return Promise
      .resolve(fingerprint || (fingerprint = getFingerprint()))
  }
})

/**
 * Gets the device fingerprint.
 */
function getFingerprint () {
  return new Promise(resolve => {
    FingerprintJs
      .get(components => {
        resolve(FingerprintJs
          .x64hash128(
            components
              .map(component => component.value)
              .join(''),
            31
          ))
      })
  })
}

/**
 * Install the session handler
 */
export function install (Vue) {
  Object.defineProperty(Vue.prototype, '$device', { value: device })
}

export default device
